import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import RoomDetailsPage from './pages/RoomDetailsPage';
import PackagesPage from './pages/PackagesPage';
import CalendarBooking from './components/CalendarBooking';
import WhatsAppButton from './components/WhatsAppButton';
import AdminLogin from './components/AdminLogin';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<HomePage />} />
          <Route path="/rooms" element={<HomePage />} />
          <Route path="/gallery" element={<HomePage />} />
          <Route path="/booking" element={<HomePage />} />
          <Route path="/contact" element={<HomePage />} />
          <Route path="/room/:roomType" element={<RoomDetailsPage />} />
          <Route path="/packages" element={<PackagesPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin-booking" element={<CalendarBooking />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
      <WhatsAppButton />
    </div>
  );
}

export default App;
